import React, { useState, useEffect } from 'react';
import moment from 'moment/moment';
import { faTrash, faDolly } from '@fortawesome/free-solid-svg-icons';
//Components
import MainCard from '../../../components/MainCard/MainCard';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import NovaOrdem from './NovaOrdem';
import FichaOrdemDeColeta from './FichaOrdemDeColeta';
import Loading from 'components/Loading/Loading';
//Api
import programacaoColeta_api from '../../../api/programacaoColeta_api';
//Helpers
import { showMessage } from 'helpers/message';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';
export default function OrdemColeta({ permissao }) {
    //Carrega a lista de ordens de coleta
    const loadOrdensDeColeta = (dataV = moment().format("YYYY-MM-DD")) => {

        setLoading(true);
        const anoMesDia = dataV.split("-");
        const _data = `${anoMesDia[2]}-${anoMesDia[1]}-${anoMesDia[0]}`;
        programacaoColeta_api.GetList(_data).then(response => {
            setItems(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }
    useEffect(() => {
        loadOrdensDeColeta();
    }, []);
    //Controle do loading na tela
    const [loading, setLoading] = useState(false);
    //Estado de controle da tela de ordem avulsa
    const [ordemAvulsa, setOrdemAvulsa] = useState(false);
    //Estado de controle do campo de data 
    const [data, setData] = useState(moment().format("YYYY-MM-DD"));
    //OnChange para a data 
    const onChangeData = (e) => {
        const { value } = e.target;
        setData(value);
    }
    //Controle da tela de ficha da ordem de coleta
    const [ficha, setFicha] = useState(null);
    //OnClick para o botão de cadastro
    const onClickBtnCadastro = () => {
        setOrdemAvulsa(true);
    }
    //OnClick do botão de ficha
    const onClickBtnFicha = (rowData) => {
        rowData.dataColeta = data;
        setFicha(rowData);
    }
    //Função do botão de voltar das telas
    const btnVoltar = () => {
        loadOrdensDeColeta(moment(data).format("YYYY-MM-DD"));
        setOrdemAvulsa(false);
        setFicha(false);
    }
    //Headers da tabela de ordens de coleta
    const headersOrdens = [
        { value: "Status", objectValue: "statusOrdem" },
        { value: "Rota", objectValue: "descricao" },
        { value: "Veículo", objectValue: "placa" },
        { value: "Total de geradores por rota", objectValue: "totalGeradoresRota" },
        { value: "Total de geradores por ordem", objectValue: "totalGeradoresOrdem" },
    ]

    //Função para remover uma ordem
    const removerOrdem = (rowData) => {
        setLoading(true);
        programacaoColeta_api.Delete(rowData.idOrdem).then(response => {
            showMessage("Sucesso", "Ordem deletada com sucesso", "success", loadOrdensDeColeta(data));
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }
    const confirmar = (rowData) => {
        const ordem = {
            tbRotaColeta_Id: rowData.idRota,
            descricao: rowData.descricao,
            dataColeta: data,
            status: "Programada",
            tbDestinos_Id: rowData.tbDestinos_Id,
            tbVeiculos_Id: rowData.idVeiculo,
            tbUsuarios_Operador_Id: rowData.tbUsuarios_Operador_Id,
            tbVeiculos_Placa: rowData.placa,
            tbDestinos_Fantasia: rowData.tbDestinos_Fantasia,
            items: rowData.items,
        }
        setLoading(true);
        programacaoColeta_api.Post(ordem).then(response => {
            showMessage("Sucesso", "Ordem de coleta programada com sucesso", "success", loadOrdensDeColeta(data));
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }
    //Variavel que guarda as ações da tabela
    const podeEditar = permissao === "Editar";
    const actions = [
        actionsTable.visualizar(onClickBtnFicha),

        (rowData) => {
            if (podeEditar && !rowData.naoPodeDeletar && rowData.statusOrdem == "Programada") {
                return actionsTable.remover(removerOrdem);
            }
        },
        (rowData) => {
            if (podeEditar && rowData.statusOrdem == "Não Programada" && new Date(data).getTime() >= new Date(moment().format("YYYY-MM-DD")).getTime()) {
                return actionsTable.confirmar(confirmar);
            }
        }
    ];
    //items da tabela de listagem
    const [items, setItems] = useState([])
    if (ordemAvulsa) {
        return <NovaOrdem ordemAvulsa btnVoltar={btnVoltar} permissao={permissao} />
    }
    if (ficha) {
        return <FichaOrdemDeColeta ordemColeta={ficha} btnVoltar={btnVoltar} permissao={permissao} />
    }
    return (
        <MainCard noCard btnCadastro={podeEditar ? "Ordem Avulsa" : null} onClickBtnCadastro={onClickBtnCadastro} search={{ name: "pesquisar", type: "date", value: data, onChange: onChangeData, onBlur: () => loadOrdensDeColeta(data), onClick: loadOrdensDeColeta }}>
            {loading && <Loading />}
            <TabelaListagem actions={actions} title='Lista de ordens de coleta' headers={headersOrdens} items={items} options={{ print: false, search: true, pagination: true }} />
        </MainCard>
    )
}